document.addEventListener("SwymStorefrontLayoutInitialized", () => {


  const OriginalSwymNotification = document.querySelector("swym-storefront-layout-notification");
  const OriginalSwymItem = customElements.get("swym-storefront-layout-item");




  if (!OriginalSwymNotification || !OriginalSwymItem) return



  const applyOverride = () => {
    const container = document.querySelector("#swym-storefront-extention-render-container");


    if (container) {
      container.addEventListener("click", (event) => {
        const loginButton = event.target.closest(".swym-storefront-layout-login-button");
        if (loginButton) {
          event.preventDefault();
          try {
            SwymStorefrontLayoutExtensions?.SwymStorefrontLayout?.close()
            window.Alpine?.store('membership')?.openMemberShipModal?.();
          } catch (error) {
            console.error(error);
          }
        }
      });
    } else {
      console.warn('not found');
    }

    }


  setTimeout(() => {
    applyOverride();
  },0)




  OriginalSwymItem.prototype.renderItem = function() {
    let localizedUrl = this.item.du
    const locale = window.Shopify.routes.root

    if (locale !== '/') {
      const splitUrl = this.item.du.split('/products/')
      localizedUrl = `${splitUrl[0]}${locale}products/${splitUrl[1]}`
    }

    this.innerHTML = `
      <div class="swym-storefront-layout-grid-item">
        <a href="${localizedUrl}" class="swym-storefront-layout-grid-item-image-container">
          <img src="${this.getProductImage()}" alt="${this.item?.dt ? this.item.dt : 'Product image'}" class="swym-storefront-layout-grid-item-image" />
        </a>
        <div class="swym-storefront-layout-grid-item-content">
          <a href="${this.item?.du}" class="swym-storefront-layout-grid-item-title">${this.item?.dt || ''}</a>
          <p class="swym-storefront-layout-grid-item-artist">${this.item?.bt || ''}</p>
         <!-- <div class="swym-storefront-layout-grid-item-price-variant"> -->
          <!--  <span class="swym-storefront-layout-grid-item-final-price">${this.getFormattedPrice()}</span> -->
         <!--   <span class="swym-storefront-layout-grid-item-compare-price">${this.getFormattedComparePrice()}</span> -->
           <!-- ${this.renderVariants()} -->
        <!--  </div> -->
          <div class="swym-storefront-layout-grid-item-action-container">
            <!--  <button class="swym-storefront-layout-grid-item-add-to-cart-button-custom" data-action="add-to-cart" -->
            <!--  ${!this.selectedVariant?.available ? 'disabled' : ''} aria-label="${this.getButtonState()}"> -->
             <!--   ${this.getButtonState().replace('+', '')} -->
        <!-- </button> -->
           <a class="swym-storefront-layout-grid-item-add-to-cart-button-custom" href="${this.item.du}">View Print</a>
            <button class="swym-storefront__remove-button">Remove</button>
            <script type="application/json" class="swym-item__json">
              {
                "item": ${JSON.stringify(this.item)}
              }
            </script>
          </div>
        </div>
        <!-- ${this.renderOptionButton()} -->
      </div>
    `;
  }

  OriginalSwymNotification.autoHide = function(duration)  {
    clearTimeout(this.timeout);
    this.showNotification();
    this.timeout = setTimeout(() => this.hideNotification(), 9000);
  }


  OriginalSwymNotification.renderUI = function() {
    if (!this.notificationData) return;

    const { message, image, iconType, title, action, actionType } = this.notificationData;
    const { showProgress, showImage, showActionButton, showMessage, showTitle } = this.notificationConfig;
    const artist = this.notificationData.product?.bt || null

    const hideFields =
      actionType === 'added-to-collection'
    this.innerHTML = `
<!--      ${showProgress ? '<div class="swym-storefront-layout-notification-progress-bar swym-storefront-notification-animated"></div>' : ''} -->
      <div class="swym-storefront-layout-notification-container">
      <div class="swym-storefront-layout-notification-close">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M1 1L9 9" stroke="black" stroke-linecap="round"/>
            <path d="M9 1L1 9" stroke="black" stroke-linecap="round"/>
      </svg>
      </div>
         ${showImage && (image || iconType) ?`<div class="swym-storefront-layout-notification-image-container">
            ${ image ? `<img class="swym-storefront-layout-notification-image" src="${image}" alt="Notification Icon">` : ''}
            ${iconType ? this.getIconHtml(iconType) : ''}
          </div>`:''}
         
         
        <div content="swym-storefront-layout-notification-custom-content"> 
        <div class="swym-storefront-layout-notification-content-container"> 
   
          <div class="swym-storefront-layout-notification-content">
            ${showTitle && title ? `<div class="swym-storefront-layout-notification-title">${title}</div>` : ''}
            ${artist && !hideFields && artist ? `<div class="swym-storefront-layout-notification-artist">${artist}</div>` : ''}
            ${showMessage && message ? `<div class="swym-storefront-layout-notification-message">${message}</div>` : ''}
          </div>
        </div>
         <div class="swym-storefront-layout-notification-actions">
<!--         ${showActionButton && action ? `<button class="swym-storefront-layout-notification-action-custom">${action.label.replace('+', '')}</button>` : ''}-->
<!--         ${showActionButton && action ? `<div class="swym-storefront-layout-notification-action-divider"></div>` : ''} -->
        ${showActionButton && action ? `<a href="#swym-list" class="swym-storefront-layout-notification-action-custom">View Wishlist</a>` : ''}
        </div>
      </div>
      </div>
    `;

    if (action) {
      this.querySelector('.swym-storefront-layout-notification-action-custom')?.addEventListener('click', (event) => {
        this.hideNotification();
        action.onClick?.(event);
      });

      this.querySelector('.swym-storefront-layout-notification-close')?.addEventListener('click', (event) => {
        this.hideNotification();
      });
    }
  }

});


document.addEventListener("SwymWishlistFetched", () => {
  initCheckWishlistEmpty();
  removeFromWishlist()
});


function initCheckWishlistEmpty() {

    const wishlists_buttons = [...document.querySelectorAll('[data-js-custom-swym-check-empty-wishlist]')];
    if (!SwymStorefrontLayoutContext) {
      return null;
    }

    // const lists = await SwymStorefrontLayoutAPI.SwymWLAsyncApis.fetchLists();
    const lists = SwymStorefrontLayoutContext.allLists;

    if (!lists?.length) {
      removeActiveWishlistClasses(wishlists_buttons);
      return null
    }

    const listsHasItems = lists.some(item => item.cnt > 0);

    if (!listsHasItems) {
      removeActiveWishlistClasses(wishlists_buttons);
      return null
    }

   addActiveWishlistClasses(wishlists_buttons);

}


function removeActiveWishlistClasses(wishlists_button) {
  wishlists_button.forEach((el) => {
    el.classList.remove('wishlist-has-items');
  });
}

function addActiveWishlistClasses(wishlists_button) {
  wishlists_button.forEach((el) => {
    el.classList.add('wishlist-has-items');
  });
}

function removeFromWishlist(product){
  window.setTimeout(()=>{
    const removeButtons = document.querySelectorAll(".swym-storefront__remove-button")
    if (removeButtons.length){
      removeButtons.forEach((button, index) => {
        button.addEventListener("click", (event) =>{
          const { item } = JSON.parse(event.currentTarget.nextElementSibling.innerHTML)
          const product = {
            epi: item.epi,  // unique variant id  per listid
            empi: item.empi, // product id
            du: item.du // product url.
          }
          SwymStorefrontLayoutAPI.SwymWLAsyncApis.removeProductFromList(product, item.lid)
        })
      })
    }
  }, 0)
}



